<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="las-imports"
            :items="tableData"
            :fields="importFields">
            <template v-slot:cell(mainGroups)="data">
                <span class="text-success">{{ data.item.mainGroups.successful }}</span>
                /
                <span class="text-danger">{{ 0 + data.item.mainGroups.failed }}</span>
            </template>

            <template v-slot:cell(groups)="data">
                <span class="text-success">{{ data.item.groups.successful }}</span>
                /
                <span class="text-danger">{{ 0 + data.item.groups.failed }}</span>
            </template>

            <template v-slot:cell(teachers)="data">
                <span class="text-success">{{ data.item.teachers.successful }}</span>
                /
                <span class="text-danger">{{ 0 + data.item.teachers.failed }}</span>
            </template>

            <template v-slot:cell(students)="data">
                <span class="text-success">{{ data.item.students.successful }}</span>
                /
                <span class="text-danger">{{ 0 + data.item.students.failed }}</span>
            </template>

            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-eye btn-view-details btn-"
                    v-b-tooltip:hover
                    variant="primary-icon-only"
                    title="Details"
                    @click="openLasImportDetails(data.item.id)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table.vue';

export default {
    name: 'design-2021-school-admin-las-import-log-component',

    components: {
        Design2021ApprenticeDataTable,
    },

    props: {
        lasImportLogsIn: Object,
    },

    // TODO: Translate
    data() {
        return {
            importFields: [
                {
                    key: 'schoolId',
                    label: 'school Id',
                },
                {
                    key: 'school',
                    label: 'school',
                },
                {
                    key: 'dateTime',
                    label: this.$t('admin.las.on'),
                },
                {
                    key: 'mainGroups',
                    label: this.$t('admin.las.main_groups'),
                },
                {
                    key: 'groups',
                    label: this.$t('admin.las.groups'),
                },
                {
                    key: 'teachers',
                    label: this.$t('admin.las.teachers'),
                },
                {
                    key: 'students',
                    label: this.$t('admin.las.students'),
                },
                {
                    key: 'provider',
                    label: this.$t('admin.las.provider'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    computed: {
        tableData() {
            return this.lasImportLogsIn
                .map((lasImportLog) => {
                    let date = new Date(lasImportLog.created_at);
                    let minutes = date.getMinutes();
                    if (minutes < 10) {
                        minutes = '0' + minutes;
                    }
                    let successful = false;
                    if (
                        lasImportLog.main_groups_successful === lasImportLog.main_groups_done &&
                        lasImportLog.groups_successful === lasImportLog.groups_done &&
                        lasImportLog.teachers_successful === lasImportLog.teachers_done &&
                        lasImportLog.students_successful === lasImportLog.students_done
                    ) {
                        successful = true;
                    }

                    // TODO: Why is lasImportLog.las_location sometimes null?

                    return {
                        schoolId: lasImportLog.las_location.school_id,
                        id: lasImportLog.id,
                        school: lasImportLog.las_location.school.name,
                        dateTime: date.toISOString().split('T')[0] + ' ' + date.getHours() + ':' + minutes,
                        createdAt: lasImportLog.created_at,
                        mainGroups: {
                            successful: lasImportLog.main_groups_successful,
                            failed: lasImportLog.main_groups_failed,
                        },
                        groups: {
                            successful: lasImportLog.groups_successful,
                            failed: lasImportLog.groups_failed,
                        },
                        teachers: {
                            successful: lasImportLog.teachers_successful,
                            failed: lasImportLog.teachers_failed,
                        },
                        students: {
                            successful: lasImportLog.students_successful,
                            failed: lasImportLog.students_failed,
                        },
                        provider: lasImportLog.provider,
                        successful: successful,
                    };
                })
                .sort(function (a, b) {
                    return new Date(b.createdAt) - new Date(a.createdAt);
                });
        },
    },
    methods: {
        openLasImportDetails(id) {
            window.location.href = this.routes.adminLasImportDetails(id);
        },
    },
};
</script>

<style scoped></style>
